export default function TimelinePoint() {
  return null;
}

TimelinePoint.displayName = "TimelinePoint";
